import { formatPlayerName } from "../utils/textUtils";
import { useSaveDashboard } from "./useWidgets";

export const useSavePlayerChart = (dashboardType) => {
  const { saveUserDashboard, getCurrentDashboard } =
    useSaveDashboard(dashboardType);

  const savePlayerChart = async (chartConfig) => {
    try {
      const {
        title,
        players, // Array of player data objects (not just IDs)
        selectedStat,
        statCategory,
        normalizeByCareer,
        type = "comparison", // 'single' or 'comparison'
      } = chartConfig;

      // Validate that we have valid player IDs
      const validPlayers = players.filter(
        (player) => player && (player.playerId || player.id)
      );

      if (validPlayers.length === 0) {
        throw new Error("No valid player IDs found");
      }

      // Only store player IDs and names - no chart data
      const processedPlayers = validPlayers.map((player) => ({
        id: player.playerId || player.id,
        name: formatPlayerName(player),
      }));

      // Create widget configuration - no chart data, only player references
      const widgetConfig = {
        type: "playerChart",
        title: String(title),
        config: {
          type: String(type),
          players: processedPlayers.map((player) => ({
            id: String(player.id),
            name: String(player.name),
          })),
          selectedStat: String(selectedStat),
          statCategory: String(statCategory),
          normalizeByCareer: Boolean(normalizeByCareer),
        },
        position: { x: 0, y: 0 }, // Will be positioned by dashboard
        size: { width: 6, height: 4 }, // Default size for charts
      };

      // Get current dashboard to ensure we have the latest data
      const dashboardResult = await getCurrentDashboard();

      if (!dashboardResult.success) {
        throw new Error(
          dashboardResult.error || "Failed to fetch current dashboard"
        );
      }

      const dashboard = dashboardResult.data;
      const currentLayout = dashboard?.layout || [];

      // Add new widget to layout
      const updatedLayout = [...currentLayout, widgetConfig];

      // Save updated dashboard

      const result = await saveUserDashboard(
        updatedLayout,
        dashboard?.gridConfig
      );

      return result;
    } catch (error) {
      console.error("Error saving player chart:", error);
      return {
        success: false,
        error: error.message || "Failed to save player chart",
      };
    }
  };

  return {
    savePlayerChart,
  };
};
